import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PagedList } from '@rma/generic/domain/types';
import { RmaUrlsService } from '@rma/generic/util/environment';
import { httpParamMapper } from '@rma/generic/util/http';
import { Observable } from 'rxjs';
import type {
  AgenciesAutoSearchResult,
  AgentsAutoSearchResult,
  AutoSearchFilter,
  AutoSearchResult,
  AutoSearchType,
  LocationsAutoSearchResult,
} from '../domain';

@Injectable({ providedIn: 'root' })
export class AutoSearchApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaUrls = inject(RmaUrlsService);

  public getAll(isLeasing: boolean, filter?: AutoSearchFilter): Observable<PagedList<AutoSearchResult>> {
    return this.httpClient.get<PagedList<AutoSearchResult>>(this.getUrl(isLeasing ? 'LeasingAll' : 'All'), this.getOptions(filter));
  }

  public getAgents(filter?: AutoSearchFilter): Observable<PagedList<AgentsAutoSearchResult>> {
    return this.httpClient.get<PagedList<AgentsAutoSearchResult>>(this.getUrl('Agents'), this.getOptions(filter));
  }

  public getAgencies(filter?: AutoSearchFilter): Observable<PagedList<AgenciesAutoSearchResult>> {
    return this.httpClient.get<PagedList<AgenciesAutoSearchResult>>(this.getUrl('Agencies'), this.getOptions(filter));
  }

  public getAgenciesAgents(filter?: AutoSearchFilter): Observable<PagedList<AgentsAutoSearchResult>> {
    return this.httpClient.get<PagedList<AgentsAutoSearchResult>>(this.getUrl('AgenciesAgents'), this.getOptions(filter));
  }

  public getLocations(filter?: AutoSearchFilter): Observable<PagedList<LocationsAutoSearchResult>> {
    return this.httpClient.get<PagedList<LocationsAutoSearchResult>>(this.getUrl('Locations'), this.getOptions(filter));
  }

  private getUrl(searchType: AutoSearchType) {
    return this.rmaUrls.apiUrl(`AutoSearch/${searchType}`);
  }

  private getOptions(filter?: AutoSearchFilter) {
    return { params: httpParamMapper(filter) };
  }
}
